<template>
  <div class="quality-base">
    <user-add user-title="资质信誉" user-add-url="/user/quality/add"></user-add>
    <div class="type-list">
      <span v-for="(item,index) in TypeList" :key="index" :class="{active: index == TypeId}"
      @click="TypeChange(index,item.code)">{{item.name}}</span>
    </div>
    <el-table :data="Cdata"  height="80vh">
      <el-table-column label="" fixed="left" width="100">
        <template slot-scope="scope" >
          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].photoUrl" alt=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" width="50" prop="id"></el-table-column>
      <el-table-column label="图片地址" prop="photoUrl" width="300" ></el-table-column>
      <el-table-column label="文字描述">
        <template slot-scope="scope">
          <span class="description" :title="Cdata[scope.$index].description">{{Cdata[scope.$index].description}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" ></el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="page"
      :page-size="1"
      style="margin-top:5px;"
      @current-change="handleCurrentChange"
      :total="Cpage"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import UserAdd from "../Common/UserAdd";
  export default {
    name: "QualityBase",
    components: {UserAdd},
    data(){
      return{
        Cdata:null,//当前表格展示数据
        Cpage:null,//当前获取数据总页数
        TypeId:0,
        TypeList:{},
        PostData:{
          'pageNumber':0,
          'pageSize':20,
          'type':1,
        }
      }
    },
    created() {
      this.GetData(this.PostData)
      this.GetTypeList()
    },
    methods:{
      GetData(PageData){
        this.$axios.post('/api/certification/getList',PageData).then(res=>{
          this.Cdata=res.data.data.records
          this.Cpage=res.data.data.pages
        })
      },
      handleCurrentChange(index){
        this.PostData.pageNumber=index;
        this.GetData(this.PostData)
      },
      GetTypeList(){
        this.$axios.get('/api/certification/getTypeList').then(res=>{

          this.TypeList=res.data.data;
        })
      },
      TypeChange(index,code){
        this.TypeId=index;
        this.PostData.type=code
        this.GetData(this.PostData)
      },
      handleLook(id){
        this.$router.push('/user/quality/look'+id)
      },
      handleChange(id){
        this.$router.push('/user/quality/change'+id)
      },
      Delete(id){
        this.$axios.delete('/api/certification/deleteById/'+id).then(res=>{
          this.GetData(this.PostData)
        })
      },
      handleDelete(id){
        this.$confirm('确定删除该条信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete(id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style lang="less" scoped>
.quality-base{
  position: relative;
  .type-list{
    position: absolute;
    z-index: 10;
    top: 15px;
    left: 100px;
    span{
      margin: 2px 15px;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
      padding: 2px 10px 10px 10px;
    }
    .active{
      border-bottom: 2px solid #188ACB;
      color: #188ACB;
    }
  }
  .description{
    width: 300px;
    height: 50px;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>